import { INSPIRATION_SCENARIO_RATES } from "web_myplann/Inspiration/constants";
import type {
	RetirementPace,
	RetirementScenarioKey,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { getRetirementRequiredContribution } from "web_myplann/Inspiration/Retirement/Utils/getRetirementRequiredContribution";

type Params = {
	targetCapital: number;
	scenario: RetirementScenarioKey;
	months: number;
	monthlyContribution: number;
};

export const getRetirementPace = ({
	targetCapital,
	scenario,
	months,
	monthlyContribution,
}: Params): RetirementPace => {
	const selectedRequiredContribution = getRetirementRequiredContribution(
		targetCapital,
		INSPIRATION_SCENARIO_RATES[scenario],
		months,
	);
	return {
		selectedRequiredContribution,
		contributionShortfall: Math.max(
			0,
			selectedRequiredContribution - monthlyContribution,
		),
	};
};
